import { Component, Prop } from 'vue-property-decorator';
import Entry from '@/components/Entry';
import Divider from '@/components/Divider';
import * as tsx from 'vue-tsx-support';
import Log from '@/components/Log';

import './style.less';

interface IEntryListProps {
  data?: any
}

@Component
export default class EntryList extends tsx.Component<IEntryListProps> {
  
  @Prop() public data!: any
  
  constructor(props: any) {
    super(props)
  }
  
  render() {
    const {data = []} = this.$props;
    return (
      <div class='entry-list'>
        {data.map(((item: any, index: number) => (
          <div class='entry-list-item'>
            <Log number={['N0141','N0142','N0143'][index]}>
              <Entry number={item.number} name={item.name} showDot={item.showDot} click={item.click}/>
            </Log>
            {index === data.length - 1 ? null :  <Divider/>}
          </div>
        )))}
      </div>
    )
  }
  
}